import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import * as Sentry from '@sentry/vue';

// 產生一個專門用於後端 api 溝通的 axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_API_PATH,
    timeout: 600000, // 10min
});

// request 發送過濾器
service.interceptors.request.use(
    (config) => {
        // 附加 Token
        config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        return config;
    },
    (error) => {
        console.log(error);
        Promise.reject(error);
    },
);

// response 接收過濾器
service.interceptors.response.use(
    (response) =>
        // 回傳成功 (200)
        response,
    (error) => {
        console.log(`err: ${error}`);

        let errorMsg = '';

        // 有取得回傳物件
        if (error.response) {
            console.log(error.response);

            // 400 = 參數不合格
            if (error.request.status === 400) {
                // errorMsg = '資料有些錯誤。';
                errorMsg = error.response.data.title;
                Sentry.captureException(error.response.data?.errors && error.response.data?.errors?.$[0]);
            }
            // 500 = 後端有回傳錯誤訊息
            else if (error.request.status === 500) {
                switch (error.response.data) {
                    // 請款單
                    case 'NO_AUTH_1':
                    case 'NO_AUTH_3':
                    case 'NO_AUTH_4_1':
                    case 'NO_AUTH_4_2':
                        errorMsg = '您沒有刪除此單的權限';
                        break;

                    case 'PA_FORBIDDEN_EDIT_OTHER':
                        errorMsg = '您沒權限(建立/編輯)此請款單';
                        break;
                    case 'PA_NOT_AUDITOR':
                        errorMsg = '您無法審核此請款單';
                        break;
                    case 'PA_UNAVAILABLE':
                        errorMsg = '無法修改單據';
                        break;
                    case 'PA_UNEDITABLE_STATUS':
                        errorMsg = '此單已在請款中無法編輯';
                        break;
                    case 'PA_FINISHED':
                        errorMsg = '此單已完成';
                        break;
                    case 'PA_NO_AUTH_A0X':
                        errorMsg = '您沒有權限';
                        break;
                    case 'PA_NO_AUTH_A01':
                        errorMsg = '您沒有新增/修改請款單的權限';
                        break;
                    case 'PA_NO_AUTH_A02':
                        errorMsg = '您沒有付款權限';
                        break;
                    case 'PA_NO_AUTH_A03':
                        errorMsg = '您沒有確認付款權限';
                        break;
                    case 'PA_NO_AUTH_A02_A03':
                        errorMsg = '您沒有權限';
                        break;
                    case 'PA_NOT_CREATOR':
                        errorMsg = '您沒有權限';
                        break;

                    // 專案
                    case 'NO_PJ_AUTH':
                        errorMsg = '您沒有專案管理權限，無法(建立/編輯)專案';
                        break;
                    case 'FORBIDDEN_EDIT_OTHER':
                        errorMsg = '您沒權限(建立/編輯)此專案';
                        break;
                    case 'NO_C04_ASSIGN_OTHER_PM':
                        errorMsg = '您沒有帳號總管理權限，無法指定 PM';
                        break;
                    default:
                        errorMsg = error.response.data;
                }
                Sentry.captureException(error.response.data);
            }
            // 其他錯誤
            else {
                errorMsg = error.response.data.title;
                Sentry.captureException(errorMsg);
            }

            // Token已過期時之處理
            if (error.request.status === 500 && error.response.data === 'Token已過期') {
                MessageBox({
                    title: 'OOPS!',
                    message: '您可能在其他裝置登入了，請重新登入。',
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    beforeClose: () => {
                        const COMPANY_NAME = window.location.pathname.split('/')[1];
                        window.location.href = `${window.location.origin}/${COMPANY_NAME}/login`;
                    },
                });
                return; // 避免Message作用
            }
        }
        // 只能送出，但無法取得回傳 （網路連線問題, cors...）
        // （目前未登入、token失效也會造成cors）
        else if (error.request) {
            errorMsg = '無法傳輸資料。';
        }
        // 其他未知錯誤
        else {
            errorMsg = error.message;
        }

        // 全域顯示錯誤訊息 (element-ui 自帶功能)
        Message({
            showClose: true,
            message: errorMsg,
            type: 'error',
            duration: 5 * 1000,
        });

        return Promise.reject(error);
    },
);

export default service;
